var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"company-create-container"},[(_vm.venderType ==='railbank')?_c('RailbankCreate'):_vm._e(),(_vm.venderType ==='modulr')?_c('ModulrCreate'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }